import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function AddStudentModal({ 
  open, 
  onOpenChange, 
  newStudent, 
  setNewStudent, 
  onSubmit, 
  school 
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Add New Student</DialogTitle>
          <DialogDescription>
            Enroll a new student to your school
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="col-span-2">
              <Label>Student Name *</Label>
              <Input
                value={newStudent.name}
                onChange={(e) => setNewStudent(prev => ({ ...prev, name: e.target.value }))}
                placeholder="Full name"
                data-testid="new-student-name"
              />
            </div>
            <div>
              <Label>Grade *</Label>
              <Select 
                value={newStudent.grade} 
                onValueChange={(value) => setNewStudent(prev => ({ ...prev, grade: value }))}
              >
                <SelectTrigger data-testid="new-student-grade">
                  <SelectValue placeholder="Select" />
                </SelectTrigger>
                <SelectContent>
                  {(school?.grades_offered || [5,6,7,8]).map(g => (
                    <SelectItem key={g} value={g.toString()}>Grade {g}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label>Section</Label>
              <Select 
                value={newStudent.section} 
                onValueChange={(value) => setNewStudent(prev => ({ ...prev, section: value }))}
              >
                <SelectTrigger data-testid="new-student-section">
                  <SelectValue placeholder="Select" />
                </SelectTrigger>
                <SelectContent>
                  {["A", "B", "C", "D", "E"].map(s => (
                    <SelectItem key={s} value={s}>Section {s}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label>Roll Number</Label>
              <Input
                value={newStudent.roll_number}
                onChange={(e) => setNewStudent(prev => ({ ...prev, roll_number: e.target.value }))}
                placeholder="e.g., 15"
                data-testid="new-student-roll"
              />
            </div>
            <div>
              <Label>Admission No.</Label>
              <Input
                value={newStudent.admission_number}
                onChange={(e) => setNewStudent(prev => ({ ...prev, admission_number: e.target.value }))}
                placeholder="e.g., ADM2024001"
                data-testid="new-student-admission"
              />
            </div>
            <div className="col-span-2">
              <Label>Parent Name</Label>
              <Input
                value={newStudent.parent_name}
                onChange={(e) => setNewStudent(prev => ({ ...prev, parent_name: e.target.value }))}
                placeholder="Parent/Guardian name"
                data-testid="new-student-parent-name"
              />
            </div>
            <div>
              <Label>Parent Email</Label>
              <Input
                type="email"
                value={newStudent.parent_email}
                onChange={(e) => setNewStudent(prev => ({ ...prev, parent_email: e.target.value }))}
                placeholder="parent@email.com"
                data-testid="new-student-parent-email"
              />
            </div>
            <div>
              <Label>Parent Phone</Label>
              <Input
                value={newStudent.parent_phone}
                onChange={(e) => setNewStudent(prev => ({ ...prev, parent_phone: e.target.value }))}
                placeholder="+91 9999999999"
                data-testid="new-student-parent-phone"
              />
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button type="submit" className="bg-emerald-600 hover:bg-emerald-700" data-testid="submit-add-student">
              Enroll Student
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default AddStudentModal;
